import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";

import {resubscribe} from '../../vendors/actions/user';
import Typography from "@material-ui/core/Typography";

interface OwnProps {
    unsubscribeUser?: any,
    resubscribeUser?: any
}

interface ConnectStateProps {

}

interface ConnectDispatchProps {
    unsubscribeUser?: (data: any) => void,
    resubscribeUser?: (data: any) => void
}

const Unsubscribe = (props: any) => {
    const {Layout} = props;
    const {unsubscribed} = Layout;

    const resubscribe = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        props.resubscribeUser(props);
    };

    console.log('unsubscribed', unsubscribed);

    return typeof unsubscribed !== 'undefined' ? (
        <Fragment>
            <div className="mb-4">
                <div className="MuiTypography-root text-center">
                    {unsubscribed ? <Fragment>
                        <Typography display="block">
                            <p>It's sad to see you go!</p>
                            <p>You have been successfully removed from our subscriber list, and will no longer receive this
                                type of communications.</p>
                            <p>If you unsubscribed by accident, you are welcome to <a href=""
                                                                                      onClick={(e) => resubscribe(e)}
                                                                                      className="">Resubscribe</a>.</p>
                        </Typography>
                    </Fragment> : <Fragment>
                            <Typography variant="h6">
                                Welcome back!
                            </Typography>
                            <Typography display="block">
                                You have been successfully subscribed.
                            </Typography>
                    </Fragment>}
                </div>
            </div>
        </Fragment>
    ) : null;
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout} = state;
    return {
        Layout
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        resubscribeUser: (data: any) => dispatch(resubscribe(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Unsubscribe);
